<template>
  <div class="tabsbar">
    <div class="row">
      <template v-for="(tabName, index) in tabNames">
        <div
          class="tabsbar-title column"
          :key="index"
          :class="tabTitleClass(tabName, index)"
          @click="tabClickAction(index)"
        >
          {{ tabName }}
        </div>
      </template>
    </div>
  </div>
</template>

<script>

export default {
  name: 'TabsBar',
  props: {
    tabNames: {
      type: Array,
      required: true,
    },
    getCurrentTab: {
      type: Function,
      default: () => {},
    },
    defaultIndex: {
      type: Number,
      default: 0,
    },
    disabledTabs: {
      type: Array,
      default: [],
    },
    disableSwitch: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      currentIndex: 0,
    }
  },
  mounted () {
    this.currentIndex = this.defaultIndex

    if (typeof this.getCurrentTab === 'function') {
      this.getCurrentTab(this.defaultIndex)
    }
  },
  methods: {
    tabClickAction (index) {
      const tabName = this.tabNames[index]
      if (!this.disableSwitch && !this.disabledTabs.includes(tabName)) {
        this.currentIndex = index

        if (typeof this.getCurrentTab === 'function') {
          this.getCurrentTab(index)
        }
      }
    },
    tabTitleClass (tabName, index) {
      const isActive = index === this.currentIndex
      const isDisabled = this.disabledTabs.includes(tabName) || (this.disableSwitch && index !== this.currentIndex)
      return {
        'is-active': isActive,
        'is-disabled': isDisabled,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~styles/_settings.scss';

.tabsbar {
  &-title {
    text-align: center;
    background-color: $white;
    color: $tender-font-color;
    cursor: pointer;
    padding: 0.625rem;
    font-size: 20px;
    border: 2px solid $light-gray;
    &.is-active {
      background-color: $tender-font-color;
      color: $white;
      border-color: $tender-font-color;
    }
    &.is-disabled {
      background-color: $light-gray;
      color: $white;
      cursor: not-allowed;
    }
  }
}

</style>
